function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DiagnosticsTemplate = require('./call-diagnostics.template');

// Call-owned, bounded history. Signaling summaries never include SDP, candidate
// addresses, credentials, or transaction bodies. Stats are sampled only on demand.
var CallDiagnostics = /*#__PURE__*/function () {
  function CallDiagnostics(app, mod) {
    var _this = this;
    _classCallCheck(this, CallDiagnostics);
    this.app = app;
    this.mod = mod;
    this.history = new Map();
    this.samples = new Map();
    this.running = false;
    this.generation = 0;
    app.connection.on('start-stun-call', function () {
      _this.stop();
      _this.history.clear();
      _this.samples.clear();
      _this.running = true;
      _this.record('local', 'Call started');
      _this.updateVisibility();
    });
    app.connection.on('videocall-ended', function () {
      return _this.stop();
    });
    app.connection.on('reset-stun', function () {
      return _this.stop();
    });
    app.connection.on('stun-diagnostic', function (peer, message) {
      var _this$mod$room_obj;
      if ((_this$mod$room_obj = _this.mod.room_obj) !== null && _this$mod$room_obj !== void 0 && (_this$mod$room_obj = _this$mod$room_obj.call_peers) !== null && _this$mod$room_obj !== void 0 && _this$mod$room_obj.includes(peer)) _this.record(peer, message);
    });
    app.connection.on('relay-transaction', function (tx) {
      var _this$mod$room_obj2;
      var msg = tx.msg;
      if ((msg === null || msg === void 0 ? void 0 : msg.module) !== 'Videocall' || msg.call_id !== ((_this$mod$room_obj2 = _this.mod.room_obj) === null || _this$mod$room_obj2 === void 0 ? void 0 : _this$mod$room_obj2.call_id)) return;
      var message = "Submitted to relay: ".concat(msg.request);
      _this.record('local', message);
      var _iterator = _createForOfIteratorHelper(tx.to || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _this$mod$room_obj3;
          var recipient = _step.value;
          if ((_this$mod$room_obj3 = _this.mod.room_obj) !== null && _this$mod$room_obj3 !== void 0 && (_this$mod$room_obj3 = _this$mod$room_obj3.call_peers) !== null && _this$mod$room_obj3 !== void 0 && _this$mod$room_obj3.includes(recipient.publicKey)) {
            _this.record(recipient.publicKey, message);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    var _loop = function _loop() {
      var event = _arr[_i];
      app.connection.on(event, function (peer) {
        var _this$mod$room_obj4;
        if ((_this$mod$room_obj4 = _this.mod.room_obj) !== null && _this$mod$room_obj4 !== void 0 && (_this$mod$room_obj4 = _this$mod$room_obj4.call_peers) !== null && _this$mod$room_obj4 !== void 0 && _this$mod$room_obj4.includes(peer)) _this.record(peer, event);
      });
    };
    for (var _i = 0, _arr = ['stun-connection-timeout', 'stun-connection-failed', 'stun-connection-close', 'stun-data-channel-open', 'stun-data-channel-close']; _i < _arr.length; _i++) {
      _loop();
    }
    var _loop2 = function _loop2() {
      var kind = _arr2[_i2];
      app.connection.on("peer-toggle-".concat(kind, "-status"), function (_ref) {
        var public_key = _ref.public_key,
          enabled = _ref.enabled;
        _this.record(public_key, "Peer reports ".concat(kind, " ").concat(enabled ? 'enabled' : 'disabled'));
      });
    };
    for (var _i2 = 0, _arr2 = ['audio', 'video']; _i2 < _arr2.length; _i2++) {
      _loop2();
    }
  }
  return _createClass(CallDiagnostics, [{
    key: "record",
    value: function record(peer, message) {
      if (!this.running || !peer) return;
      if (peer === this.mod.publicKey) peer = 'local';
      // Bound both peers and entries, including peers that have since left.
      if (!this.history.has(peer)) {
        if (this.history.size >= 64) this.history["delete"](this.history.keys().next().value);
        this.history.set(peer, []);
      }
      var entries = this.history.get(peer);
      entries.push("".concat(new Date().toISOString().slice(11, 23), " ").concat(String(message).slice(0, 300)));
      if (entries.length > 100) entries.shift();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.running = false;
      this.samples.clear();
      this.generation++;
      clearInterval(this.timer);
      this.timer = null;
      if (typeof document !== 'undefined') {
        document.querySelectorAll('.videocall-diagnostics').forEach(function (panel) {
          return panel.remove();
        });
      }
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      var _this$app$options$stu,
        _this2 = this;
      this.generation++;
      clearInterval(this.timer);
      this.timer = null;
      if (!this.running || !((_this$app$options$stu = this.app.options.stun) !== null && _this$app$options$stu !== void 0 && (_this$app$options$stu = _this$app$options$stu.settings) !== null && _this$app$options$stu !== void 0 && _this$app$options$stu.diagnostics)) {
        if (typeof document !== 'undefined') {
          document.querySelectorAll('.videocall-diagnostics').forEach(function (panel) {
            return panel.remove();
          });
        }
        return;
      }
      void this.refresh();
      this.timer = setInterval(function () {
        return void _this2.refresh();
      }, 2000);
    }
  }, {
    key: "trackStatus",
    value: function trackStatus(track) {
      return "".concat(track.kind, ": ").concat(track.readyState, ", ").concat(track.enabled ? 'enabled' : 'disabled', ", ").concat(track.muted ? 'muted/no data' : 'unmuted');
    }
  }, {
    key: "sample",
    value: function () {
      var _sample = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(peer, pc) {
        var generation, stats, lines, previous, current, _iterator2, _step2, _this$mod$stun, key;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              generation = this.generation;
              _context.n = 1;
              return pc.getStats();
            case 1:
              stats = _context.v;
              lines = [];
              previous = this.samples.get(peer);
              current = new Map();
              stats.forEach(function (report) {
                if (report.type === 'inbound-rtp' || report.type === 'outbound-rtp') {
                  var _report$packetsLost;
                  var incoming = report.type === 'inbound-rtp';
                  var bytes = report[incoming ? 'bytesReceived' : 'bytesSent'] || 0;
                  var packets = report[incoming ? 'packetsReceived' : 'packetsSent'] || 0;
                  var frames = report[incoming ? 'framesDecoded' : 'framesEncoded'];
                  var old = (previous === null || previous === void 0 ? void 0 : previous.pc) === pc ? previous.reports.get(report.id) : null;
                  var elapsed = old ? (report.timestamp - old.timestamp) / 1000 : 0;
                  var rate = elapsed > 0 && bytes >= old.bytes ? ", ".concat(((bytes - old.bytes) * 8 / elapsed / 1000).toFixed(1), " kb/s") : '';
                  var progress = old && frames !== undefined && old.frames !== undefined ? " (+".concat(Math.max(0, frames - old.frames), ")") : '';
                  lines.push("".concat(incoming ? 'IN' : 'OUT', " ").concat(report.kind || report.mediaType, ": ").concat(bytes, " bytes, ").concat(packets, " packets").concat(rate).concat(frames !== undefined ? ", ".concat(frames, " frames").concat(progress) : '').concat(incoming ? ", lost ".concat((_report$packetsLost = report.packetsLost) !== null && _report$packetsLost !== void 0 ? _report$packetsLost : '?') : ''));
                  current.set(report.id, {
                    bytes: bytes,
                    frames: frames,
                    timestamp: report.timestamp
                  });
                }
                if (report.type === 'transport' && report.selectedCandidatePairId) {
                  var pair = stats.get(report.selectedCandidatePairId);
                  if (!pair) return;
                  var local = stats.get(pair.localCandidateId);
                  var remote = stats.get(pair.remoteCandidateId);
                  lines.push("Route: ".concat((local === null || local === void 0 ? void 0 : local.candidateType) || '?', " \u2192 ").concat((remote === null || remote === void 0 ? void 0 : remote.candidateType) || '?', " (").concat((local === null || local === void 0 ? void 0 : local.protocol) || '?', ")").concat(pair.currentRoundTripTime !== undefined ? ", RTT ".concat(Math.round(pair.currentRoundTripTime * 1000), " ms") : ''));
                }
              });
              if (!(generation !== this.generation || !this.running)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, lines);
            case 2:
              this.samples.set(peer, {
                pc: pc,
                reports: current
              });
              // Stale peer samples are unnecessary once a connection is removed.
              _iterator2 = _createForOfIteratorHelper(this.samples.keys());
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  key = _step2.value;
                  if (!((_this$mod$stun = this.mod.stun) !== null && _this$mod$stun !== void 0 && _this$mod$stun.peers.has(key))) this.samples["delete"](key);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return _context.a(2, lines.length ? lines : ['No RTP media statistics yet']);
          }
        }, _callee, this);
      }));
      function sample(_x, _x2) {
        return _sample.apply(this, arguments);
      }
      return sample;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        var generation, _this$mod$room_obj5, ids;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(this.refreshing || !this.running)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.refreshing = true;
              generation = this.generation;
              _context3.p = 2;
              ids = new Set(['local', 'connecting', 'presentation'].concat(_toConsumableArray(((_this$mod$room_obj5 = this.mod.room_obj) === null || _this$mod$room_obj5 === void 0 ? void 0 : _this$mod$room_obj5.call_peers) || []), _toConsumableArray(this.history.keys())));
              _context3.n = 3;
              return Promise.all(_toConsumableArray(ids).map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
                  var _this3$mod$stun, _media$srcObject, _media$readyState;
                  var box, peer, pc, media, lines, _pc$dc, _pc$pendingCandidates, _iterator3, _step3, sender, _iterator4, _step4, receiver, tracks, _media$getVideoPlayba, _media$getVideoPlayba2, panel, _i3, _arr3, event, log, follow, _t, _t2, _t3, _t4;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        box = document.getElementById("stream_".concat(id)) || document.getElementById("audiostream_".concat(id));
                        if (box) {
                          _context2.n = 1;
                          break;
                        }
                        return _context2.a(2);
                      case 1:
                        peer = id === 'presentation' ? _this3.mod.screen_share === true ? 'local' : _this3.mod.screen_share : id;
                        pc = (_this3$mod$stun = _this3.mod.stun) === null || _this3$mod$stun === void 0 ? void 0 : _this3$mod$stun.peers.get(peer);
                        media = box.querySelector('video, audio');
                        lines = [];
                        if (!(peer === 'local')) {
                          _context2.n = 2;
                          break;
                        }
                        lines.push('Local capture / preview');
                        _context2.n = 8;
                        break;
                      case 2:
                        if (!pc) {
                          _context2.n = 7;
                          break;
                        }
                        lines.push("Connection: ".concat(pc.connectionState, " | ICE: ").concat(pc.iceConnectionState));
                        lines.push("Signaling: ".concat(pc.signalingState, " | Gathering: ").concat(pc.iceGatheringState));
                        lines.push("Data channel: ".concat(((_pc$dc = pc.dc) === null || _pc$dc === void 0 ? void 0 : _pc$dc.readyState) || 'none', " | Queued ICE: ").concat(((_pc$pendingCandidates = pc.pendingCandidates) === null || _pc$pendingCandidates === void 0 ? void 0 : _pc$pendingCandidates.length) || 0));
                        _iterator3 = _createForOfIteratorHelper(pc.getSenders());
                        try {
                          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                            sender = _step3.value;
                            if (sender.track) lines.push("Send ".concat(_this3.trackStatus(sender.track)));
                          }
                        } catch (err) {
                          _iterator3.e(err);
                        } finally {
                          _iterator3.f();
                        }
                        _iterator4 = _createForOfIteratorHelper(pc.getReceivers());
                        try {
                          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                            receiver = _step4.value;
                            if (receiver.track) lines.push("Receive ".concat(_this3.trackStatus(receiver.track)));
                          }
                        } catch (err) {
                          _iterator4.e(err);
                        } finally {
                          _iterator4.f();
                        }
                        _context2.p = 3;
                        _t = lines.push;
                        _t2 = lines;
                        _t3 = _toConsumableArray;
                        _context2.n = 4;
                        return _this3.sample(peer, pc);
                      case 4:
                        _t.apply.call(_t, _t2, _t3(_context2.v));
                        _context2.n = 6;
                        break;
                      case 5:
                        _context2.p = 5;
                        _t4 = _context2.v;
                        lines.push("Stats unavailable: ".concat(_t4.name));
                      case 6:
                        _context2.n = 8;
                        break;
                      case 7:
                        lines.push('Waiting for peer connection');
                      case 8:
                        tracks = (media === null || media === void 0 || (_media$srcObject = media.srcObject) === null || _media$srcObject === void 0 ? void 0 : _media$srcObject.getTracks()) || [];
                        if (peer === 'local') tracks.forEach(function (track) {
                          return lines.push(_this3.trackStatus(track));
                        });
                        lines.push("Playback: ".concat(!(media !== null && media !== void 0 && media.srcObject) ? 'no stream attached' : media.paused ? 'paused (autoplay may be blocked)' : 'playing', ", readyState ").concat((_media$readyState = media === null || media === void 0 ? void 0 : media.readyState) !== null && _media$readyState !== void 0 ? _media$readyState : '?'));
                        if ((media === null || media === void 0 ? void 0 : media.tagName) === 'VIDEO') {
                          lines.push("Video: ".concat(media.videoWidth, "\xD7").concat(media.videoHeight, ", rendered frames ").concat((_media$getVideoPlayba = (_media$getVideoPlayba2 = media.getVideoPlaybackQuality) === null || _media$getVideoPlayba2 === void 0 ? void 0 : _media$getVideoPlayba2.call(media).totalVideoFrames) !== null && _media$getVideoPlayba !== void 0 ? _media$getVideoPlayba : '?'));
                        }
                        if (media !== null && media !== void 0 && media.error) lines.push("Playback error: ".concat(media.error.code));
                        if (!tracks.some(function (track) {
                          return track.kind === 'video';
                        })) lines.push('No video track attached (camera may be off or audio-only call)');
                        if (!(generation !== _this3.generation || !_this3.running || !box.isConnected)) {
                          _context2.n = 9;
                          break;
                        }
                        return _context2.a(2);
                      case 9:
                        panel = box.querySelector('.videocall-diagnostics');
                        if (!panel) {
                          box.insertAdjacentHTML('beforeend', DiagnosticsTemplate());
                          panel = box.querySelector('.videocall-diagnostics');
                          // Opening/selecting log text must not flip or drag the video tile.
                          for (_i3 = 0, _arr3 = ['click', 'dblclick', 'pointerdown', 'mousedown', 'touchstart']; _i3 < _arr3.length; _i3++) {
                            event = _arr3[_i3];
                            panel.addEventListener(event, function (e) {
                              return e.stopPropagation();
                            });
                          }
                        }
                        panel.querySelector('.videocall-diagnostics-status').textContent = lines.join('\n');
                        log = panel.querySelector('.videocall-diagnostics-log');
                        follow = log.scrollHeight - log.scrollTop - log.clientHeight < 20;
                        log.textContent = (_this3.history.get(peer === 'connecting' ? 'local' : peer) || ['No events recorded in this call yet']).join('\n');
                        if (follow) log.scrollTop = log.scrollHeight;
                      case 10:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[3, 5]]);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 3:
              _context3.p = 3;
              this.refreshing = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[2,, 3, 4]]);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }()
  }]);
}();
module.exports = CallDiagnostics;